import { inventoryItemFields, inventoryItemTypes } from "@rpforms/shared";
import { EDIT_INVENTORY_ITEM, NEW_INVENTORY_ITEM } from "@rpforms/shared/build/actions";
import { openEditor } from "@rpforms/shared/build/actions/editor";
import { approveInventoryItem } from "@rpforms/shared/build/actions/inventory_items";
import { SmallButton, SmallDangerButton } from "@rpforms/shared/build/components/layout/Button";
import { skillLabels } from "@rpforms/shared/build/constants";
import React from "react";
import { Badge } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { COMPANY_ID } from "../../config";
import { ListRow } from "../forms/FormListRow";
import { ActionCell, ActionLine } from "./RowActions";

const InventoryItemTableRow = ({
    inventoryItem,
    deleteInventoryItem = null,
    type = "repair",
    presentationType = "table-row",
    onUpdated,
}: any) => {
    const dispatch = useDispatch();

    const confirmAction = (cb) => {
        if (confirm("Sind Sie sich sicher dieses Objekt zu löschen?")) {
            cb();
        }
    };

    const editInventoryItem = () => {
        dispatch(
            openEditor({
                endpoint: `inventory_items`,
                endpointCompany: false,
                new: !inventoryItem.id,
                preload: {
                    sales_price: 0,
                    buying_price: 0,
                    manufacturer: inventoryItem.manufacturer || {},
                    category: inventoryItem.category || {},
                    company_id: COMPANY_ID,
                    ...inventoryItem,
                },
                type: !inventoryItem.id ? NEW_INVENTORY_ITEM : EDIT_INVENTORY_ITEM,
                submitCallback: () => {
                    if (onUpdated) {
                        onUpdated();
                    }
                },
            })
        );
    };

    const approve = async () => {
        await dispatch(approveInventoryItem(inventoryItem));
        if (onUpdated) {
            onUpdated();
        }
    };

    const duplicateInventoryItem = () => {
        dispatch(
            openEditor({
                endpoint: `inventory_items`,
                endpointCompany: false,
                new: true,
                preload: {
                    sales_price: inventoryItem.sales_price || 0,
                    buying_price: inventoryItem.buying_price || 0,
                    manufacturer: inventoryItem.manufacturer || {},
                    category: inventoryItem.category || {},
                    company_id: COMPANY_ID,
                    name: inventoryItem.name,
                    short_name: inventoryItem.short_name,
                    description: inventoryItem.description,
                    quantity: inventoryItem.quantity,
                    manufacturer_id: inventoryItem.manufacturer_id,
                    manufacturer_name: inventoryItem.manufacturer_name,
                    category_id: inventoryItem.category_id,
                    category_name: inventoryItem.category_name,
                    inventory_type: inventoryItem.inventory_type,
                    nr: inventoryItem.nr,
                    allowed_form_types: inventoryItem.allowed_form_types || [],
                    skills: inventoryItem.skills || [],
                },
                type: NEW_INVENTORY_ITEM,
                submitCallback: () => {
                    if (onUpdated) {
                        onUpdated();
                    }
                },
            })
        );
    };

    const tr = (
        <tr key={`inbentory-item-row${inventoryItem.id}`}>
            {inventoryItemFields(type).map((fieldHash) => {
                const field = fieldHash.attribute_name;
                if (field === "name") {
                    return (
                        <td key={"attr-" + field} className={fieldHash.className}>
                            <strong>{inventoryItem[field]}</strong>
                        </td>
                    );
                } else if (field === "skills") {
                    return (
                        <td key={"attr-" + field} className={fieldHash.className}>
                            {skillLabels(inventoryItem.skills) || <>–</>}
                        </td>
                    );
                } else if (["manufacturer", "category"].includes(field)) {
                    return (
                        <td key={"attr-" + field} className={fieldHash.className}>
                            {inventoryItem[field + "_id"] && inventoryItem[field + "_name"]}
                            {!inventoryItem[field + "_id"] && <>–</>}
                        </td>
                    );
                } else {
                    return (
                        <td key={"attr-" + field} className={fieldHash.className}>
                            {inventoryItem[field]}
                        </td>
                    );
                }
            })}
            <td>
                <ActionCell>
                    {(presentationType === "list-row" ||
                        inventoryItem.source === "ai_import" ||
                        inventoryItem.approved === false) && (
                        <ActionLine>
                            {presentationType === "list-row" && (
                                <Badge style={{ backgroundColor: "#777", color: "#ffffff" }}>
                                    {inventoryItemTypes()[inventoryItem.inventory_type]}
                                </Badge>
                            )}
                            {inventoryItem.source === "ai_import" && (
                                <Badge variant="info">KI-Import</Badge>
                            )}
                            {inventoryItem.approved === false && (
                                <Badge variant="warning">Nicht freigegeben</Badge>
                            )}
                        </ActionLine>
                    )}
                    <ActionLine>
                        {inventoryItem.approved === false && (
                            <SmallButton onClick={approve}>Freigeben</SmallButton>
                        )}
                        <SmallButton onClick={editInventoryItem}>Bearbeiten</SmallButton>
                        <SmallButton onClick={duplicateInventoryItem}>Duplizieren</SmallButton>
                        {deleteInventoryItem !== null && (
                            <SmallDangerButton
                                onClick={() =>
                                    confirmAction(() => deleteInventoryItem(inventoryItem))
                                }
                            >
                                <i className={"fa fa-trash"}></i>
                            </SmallDangerButton>
                        )}
                    </ActionLine>
                </ActionCell>
            </td>
        </tr>
    );

    const r = () => {
        if (presentationType === "table-row") {
            return tr;
        } else if (presentationType === "list-row") {
            return (
                <ListRow>
                    <table>{tr}</table>
                </ListRow>
            );
        }
    };

    return r();
};

export default withRouter(InventoryItemTableRow);
